import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { ScrollArea } from 'react-wot-bootstrap'

import { MQ_BREAKPOINTS } from 'constants'
import { formatter, mq } from 'helpers'

import { CopyrightInfo } from '../CopyrightInfo/CopyrightInfo'

import styles from './Body.scss'

const SCROLLABLE_AREA_HEIGHT_SMALL = 250
const SCROLLABLE_AREA_HEIGHT_BIG = 300

export class Body extends React.Component {
    static propTypes = {
        body: PropTypes.string.isRequired,
        accountId: PropTypes.number.isRequired,
    }

    state = {
        scrollableAreaHeight: 0,
        isBodyScrollable: false,
    }

    componentDidMount() {
        this.updateScrollableAreaHeight()
        window.addEventListener('resize', this.updateScrollableAreaHeight)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScrollableAreaHeight)
    }

    updateScrollableAreaHeight = () => {
        const scrollableAreaHeight = mq(MQ_BREAKPOINTS.M) ?
            SCROLLABLE_AREA_HEIGHT_BIG :
            SCROLLABLE_AREA_HEIGHT_SMALL

        const contentHeight = this._content ? this._content.clientHeight : 0

        this.setState({
            scrollableAreaHeight,
            isBodyScrollable: scrollableAreaHeight < contentHeight,
        })
    }

    render() {
        const { scrollableAreaHeight, isBodyScrollable } = this.state
        const body = formatter(this.props.body)

        const contentClassNames = classNames(
            styles.content,
            isBodyScrollable && styles.content__scrollable,
        )

        const announcementInfoClassNames = classNames(
            styles.announcementInfo,
            !isBodyScrollable && styles.announcementInfo__dots,
        )

        return (
            <div className={styles.base}>
                <div className={contentClassNames}>
                    <ScrollArea scrollableAreaHeight={scrollableAreaHeight}>
                        <p
                            className={styles.message}
                            dangerouslySetInnerHTML={{ __html: body }}
                            ref={c => this._content = c}
                        />
                    </ScrollArea>
                </div>
                <div className={announcementInfoClassNames}>
                    <CopyrightInfo
                        {...this.props}
                        timeClassName={styles.announcementTime}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/Body/Body.jsx